<template>
    <router-link class="r-announcement-card" :to="{name: 'announcementDetail', params: {slug: data.slug}}">
        <div class="r-isFlex r-announcement-card-img">
            <img class="r-isExpand" :src="data.banner" :alt="data.title">
        </div>
        <h5 class="r-mb-10">{{data.title}}</h5>
        <div class="r-mb-10">
            <p class="line-clamp">{{data.short_description}}</p>
        </div>
        <p class="r-mt-auto r-black-60-text">{{customFormat(data.updated_at)}}</p>
    </router-link>
</template>
<script>
import { customFormat } from '@/common/timeformat'

export default {
    props: {
        data: {
            require: true
        },
    },
    methods:{
        customFormat(value){
            if(!value) return '-'
            return customFormat(value, 'DD MMMM YYYY')
        }
    }
}
</script>